module.exports = __webpack_public_path__ + "img/safe03.26d69d7c.png";